<template>
  <v-main v-if="jobOffer !== null && seeker !== null" style="min-height: 70vh">
    <v-container class="responsive-template-content">
      <v-row dense>
        <v-col cols="12">
          <v-col class="col-md-12 col-sm-12 col-xs-12">
            <v-card color="white" dark elevation="0" class="rounded-xl">
              <v-card-title
                class="justify-center text-h5 font-weight-light"
                style="color: #1976d2"
              >
                <v-icon color="#1976D2"> mdi-text-box-check </v-icon>
                Envoyer une candidature
              </v-card-title>

              <v-card-subtitle>
                <section
                  style="background: rgba(255, 255, 255, 0.9); color: #777171"
                >
                  <v-col>
                    <v-row justify="center" style="padding-top: 2em">
                      <v-expansion-panels
                        accordion
                        light
                        v-model="panel"
                        multiple
                      >
                        <v-expansion-panel key="0">
                          <v-expansion-panel-header
                            class="text-h5 font-weight-light"
                          >
                            Résumé de l'offre
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div class="text-h6 font-weight-thin">
                              {{ jobOffer.job.name }} -
                              {{ jobOffer.type.name }} publiée par
                              {{ jobOffer.company.name }}
                            </div>
                            <div
                              class="font-weight-light"
                              v-html="
                                `${jobOffer.description.substr(0, 500)} ...`
                              "
                            ></div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel key="1">
                          <v-expansion-panel-header
                            class="text-h5 font-weight-light"
                          >
                            Ma candidature
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row v-if="submitionSucceed">
                              <v-col cols="12">
                                <v-alert type="success"
                                  >Votre candidature a bien été transmise à
                                  l'entreprise. Vous aller recevoir un email de
                                  confirmation.
                                </v-alert>
                              </v-col>
                              <v-col cols="12">
                                <router-link
                                  to="/candidate/offers?loadLastResearch=true"
                                >
                                  <v-icon>mdi-arrow-left</v-icon>
                                  Revenir aux offres d'emplois
                                </router-link>
                              </v-col>
                            </v-row>
                            <v-stepper
                              v-model="e6"
                              vertical
                              elevation="0"
                              v-if="submitionOngoing"
                            >
                              <v-stepper-step :complete="e6 > 1" step="1">
                                Mon CV
                                <small>Curriculum vitæ</small>
                              </v-stepper-step>

                              <v-stepper-content step="1">
                                <v-card class="mb-12" elevation="0">
                                  <v-card-text>
                                    <v-row>
                                      <v-col
                                        cols="12"
                                        md="4"
                                        v-if="
                                          seeker !== null &&
                                          seeker.defaultCvTemplate
                                        "
                                      >
                                        <div class="row">
                                          <v-checkbox
                                            v-model="
                                              submittionForm.useGeneratedCv
                                            "
                                            :disabled="
                                              submittionForm.disableUseOldGeneratedCv
                                            "
                                          >
                                            <template v-slot:label>
                                              <div>
                                                Utiliser mon dernier
                                                <v-tooltip bottom>
                                                  <template
                                                    v-slot:activator="{ on }"
                                                  >
                                                    <a
                                                      target="_blank"
                                                      :href="
                                                        currentGeneratedCvFilePath
                                                      "
                                                      @click.stop
                                                      v-on="on"
                                                    >
                                                      CV généré sur Kira RH
                                                    </a>
                                                  </template>
                                                  Cliquez pour consulter le
                                                  fichier
                                                </v-tooltip>
                                              </div>
                                            </template>
                                          </v-checkbox>
                                        </div>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="4"
                                        v-if="seeker !== null && seeker.cv"
                                      >
                                        <div class="row">
                                          <v-checkbox
                                            v-model="submittionForm.useOldCv"
                                            :disabled="
                                              submittionForm.disableUseOldCv
                                            "
                                          >
                                            <template v-slot:label>
                                              <div>
                                                Utiliser mon dernier
                                                <v-tooltip bottom>
                                                  <template
                                                    v-slot:activator="{ on }"
                                                  >
                                                    <a
                                                      target="_blank"
                                                      :href="currentCvFilePath"
                                                      @click.stop
                                                      v-on="on"
                                                    >
                                                      CV téléchargé
                                                    </a>
                                                  </template>
                                                  Cliquez pour consulter le
                                                  fichier
                                                </v-tooltip>
                                              </div>
                                            </template>
                                          </v-checkbox>
                                        </div>
                                      </v-col>
                                      <v-col cols="12" md="4">
                                        <div class="row">
                                          <v-file-input
                                            v-model="submittionForm.cv"
                                            :disabled="
                                              submittionForm.disableUploadCv
                                            "
                                            truncate-length="30"
                                            placeholder="Ajouter un CV"
                                            prepend-icon="mdi-upload-outline"
                                            show-size
                                            accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
text/plain, application/pdf, image/*"
                                          >
                                            <template
                                              v-slot:selection="{ text }"
                                            >
                                              <v-chip
                                                small
                                                label
                                                color="primary"
                                              >
                                                {{ text }}
                                              </v-chip>
                                            </template>
                                          </v-file-input>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="e6 = 2"
                                  :disabled="disableContinue1"
                                >
                                  Continuer
                                </v-btn>
                              </v-stepper-content>

                              <v-stepper-step :complete="e6 > 2" step="2">
                                Ma lettre de motivation
                              </v-stepper-step>

                              <v-stepper-content step="2">
                                <v-card elevation="0">
                                  <v-card-text>
                                    <v-textarea
                                      solo
                                      name="input-7-4"
                                      label="Lettre de motivation"
                                      shaped
                                      height="250"
                                      no-resize
                                      v-model="submittionForm.lm"
                                    ></v-textarea>
                                    <span
                                      v-if="displayWarningMessage"
                                      style="color: #ffa700"
                                    >
                                      La lettre de motivation doit contenir au
                                      moins 350 caractères
                                    </span>
                                  </v-card-text>
                                </v-card>
                                <v-btn
                                  color="success"
                                  outlined
                                  @click="submitApplication"
                                  :disabled="disableSubmitMyCandidature"
                                >
                                  <v-icon left> mdi-check </v-icon>
                                  Soumettre ma candidature
                                </v-btn>
                                <v-btn text @click="e6 = 1">
                                  Revenir en arrière
                                </v-btn>
                              </v-stepper-content>
                            </v-stepper>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                      <v-snackbar
                        v-model="snackbarFailed"
                        rounded="pill"
                        elevation="24"
                        color="red darken-3"
                      >
                        <span class="text-subtitle-1">
                          {{ snackbarFailedMessage }}
                        </span>
                        <template v-slot:action="{ attrs }">
                          <v-btn
                            color="black"
                            text
                            v-bind="attrs"
                            @click="snackbarFailed = false"
                          >
                            Fermer
                          </v-btn>
                        </template>
                      </v-snackbar>
                      <v-snackbar
                        v-model="snackbarSucceed"
                        rounded="pill"
                        elevation="24"
                        color="green darken-3"
                      >
                        <span class="text-subtitle-1">
                          {{ snackbarSucceedMessage }}
                        </span>
                        <template v-slot:action="{ attrs }">
                          <v-btn
                            color="black"
                            text
                            v-bind="attrs"
                            @click="snackbarSucceed = false"
                          >
                            Fermer
                          </v-btn>
                        </template>
                      </v-snackbar>
                    </v-row>
                  </v-col>
                </section>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";

export default Vue.extend({
  name: "CandidateApplyToOffer.vue",
  components: {},
  data: () => ({
    panel: [0, 1],
    jobOffer: null,
    snackbarFailed: false,
    snackbarSucceed: false,
    snackbarFailedMessage: "",
    snackbarSucceedMessage: "",
    disableContinue1: true,
    disableSubmitMyCandidature: true,
    seeker: null,
    currentCvFilePath: null,
    currentGeneratedCvFilePath: null,
    displayWarningMessage: false,
    submitionOngoing: true,
    submitionSucceed: false,
    submittionForm: {
      cv: null,
      lm: "",
      useOldCv: false,
      useGeneratedCv: false,
      disableUseOldGeneratedCv: false,
      disableUseOldCv: false,
      disableUploadCv: false,
    },
    e6: 1,
  }),
  computed: {
    cv() {
      return this.submittionForm.cv;
    },

    useOldCv() {
      return this.submittionForm.useOldCv;
    },

    useGeneratedCv() {
      return this.submittionForm.useGeneratedCv;
    },

    lm() {
      return this.submittionForm.lm;
    },
  },

  watch: {
    cv: function (val) {
      console.log(val);
      if (val === null) {
        this.submittionForm.disableUseOldCv = false;
        this.submittionForm.disableUseOldGeneratedCv = false;
      } else {
        this.submittionForm.disableUseOldCv = true;
        this.submittionForm.useOldCv = false;

        this.submittionForm.disableUseOldGeneratedCv = true;
        this.submittionForm.useGeneratedCv = false;
      }
      this.submitionNextStep();
    },

    useOldCv(val) {
      console.log(val);
      if (val === true) {
        this.submittionForm.disableUploadCv = true;
        this.submittionForm.cv = null;

        this.submittionForm.disableUseOldGeneratedCv = true;
        this.submittionForm.useGeneratedCv = false;
      } else {
        this.submittionForm.disableUploadCv = false;
        this.submittionForm.disableUseOldGeneratedCv = false;
      }

      this.submitionNextStep();
    },

    useGeneratedCv(val) {
      console.log(val);
      if (val === true) {
        this.submittionForm.disableUploadCv = true;
        this.submittionForm.cv = null;
        this.submittionForm.disableUseOldCv = true;
        this.submittionForm.useOldCv = false;
      } else {
        this.submittionForm.disableUploadCv = false;
        this.submittionForm.disableUseOldCv = false;
      }

      this.submitionNextStep();
    },

    lm(val) {
      console.log(val);
      if (!val || val.trim() === "") {
        this.disableSubmitMyCandidature = true;
        this.displayWarningMessage = false;
      } else if (val.length < 350) {
        this.disableSubmitMyCandidature = true;
        this.displayWarningMessage = true;
      } else {
        this.displayWarningMessage = false;
        if (
          this.submittionForm.useOldCv === true ||
          this.submittionForm.cv !== null ||
          this.submittionForm.useGeneratedCv
        ) {
          this.disableSubmitMyCandidature = false;
        } else {
          this.disableSubmitMyCandidature = true;
        }
      }
    },
  },

  created() {
    this.initialize();
    this.fetchCurrentSeeker();
  },

  methods: {
    checkIfUserHasAlreadySubmitted(id) {
      const httpClient = new HttpClient();
      httpClient
        .getApplication(id, localStorage.getItem("jwt-token"))
        .then(() => {
          this.submitionOngoing = false;
          this.submitionSucceed = true;
        });
    },
    fetchCurrentSeeker() {
      const httpClient = new HttpClient();
      httpClient
        .getCurrentSeeker(localStorage.getItem("jwt-token"))
        .then((res) => {
          this.seeker = res.data;
          if (this.seeker.cv)
            this.currentCvFilePath = `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/uploads/cv/${this.seeker.cv.fileName}`;

          if (res.data.defaultCvTemplate) {
            const currentTemplate = res.data.defaultCvTemplate;
            const currentUser = JSON.parse(localStorage.getItem("currentUser"));
            this.currentGeneratedCvFilePath = `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/download/resume/${currentTemplate.id}/${currentUser.id}`;
            console.log(this.currentGeneratedCvFilePath);
          }

          console.log(this.seeker);
        });
    },
    submitApplication() {
      if (
        this.submittionForm.useOldCv ||
        this.submittionForm.cv !== null ||
        this.submittionForm.useGeneratedCv
      ) {
        if (this.jobOffer.coverLetter) {
          if (this.lm.length >= 350 && this.lm.trim() !== "") {
            const httpClient = new HttpClient();
            //first off upload cv file
            if (
              !this.submittionForm.useOldCv &&
              !this.submittionForm.useGeneratedCv &&
              this.submittionForm.cv !== null
            ) {
              const formData = new FormData();
              formData.append("cvFile", this.submittionForm.cv);
              httpClient
                .uploadSeekerCvFile(formData, localStorage.getItem("jwt-token"))
                .then((value) => {
                  httpClient
                    .createNewApplication(
                      {
                        jobOffer: this.jobOffer.id,
                        coverLetter: this.submittionForm.lm,
                      },
                      localStorage.getItem("jwt-token")
                    )
                    .then((result) => {
                      console.log(result.data);
                      this.submitionOngoing = false;
                      this.submitionSucceed = true;
                    })
                    .catch((error) => {
                      if (error.response.status === 401) {
                        this.$router.push("/logout");
                      } else if (error.response.status === 503) {
                        this.snackbarFailedMessage =
                          "Vous avez déjà postulé à cette offre.";
                        this.snackbarFailed = true;
                      } else {
                        this.snackbarFailedMessage =
                          "Une erreur s'est produite avec le CV. Format invalide. Veuillez réessayer.";
                        this.snackbarFailed = true;
                      }
                    });
                })
                .catch((error) => {
                  if (error.response.status === 401) {
                    this.$router.push("/logout");
                  } else if (error.response.status === 503) {
                    this.snackbarFailedMessage =
                      "Vous avez déjà postulé à cette offre.";
                    this.snackbarFailed = true;
                  } else {
                    this.snackbarFailedMessage =
                      "Une erreur s'est produite avec le CV. Format invalide. Veuillez réessayer.";
                    this.snackbarFailed = true;
                  }
                });
            } else {
              //submit directly application
              httpClient
                .createNewApplication(
                  {
                    jobOffer: this.jobOffer.id,
                    coverLetter: this.submittionForm.lm,
                  },
                  localStorage.getItem("jwt-token")
                )
                .then((result) => {
                  console.log(result.data);
                  this.submitionOngoing = false;
                  this.submitionSucceed = true;
                })
                .catch((error) => {
                  if (error.response.status === 401) {
                    this.$router.push("/logout");
                  } else if (error.response.status === 503) {
                    this.snackbarFailedMessage =
                      "Vous avez déjà postulé à cette offre.";
                    this.snackbarFailed = true;
                  } else {
                    this.snackbarFailedMessage =
                      "Une erreur s'est produite avec le CV. Format invalide. Veuillez réessayer.";
                    this.snackbarFailed = true;
                  }
                });
            }
          } else {
            alert("La lettre de motivation est obligatoire");
          }
        } else {
          const httpClient = new HttpClient();
          if (
            !this.submittionForm.useOldCv &&
            this.submittionForm.cv !== null
          ) {
            //first off upload cv file
            const formData = new FormData();
            formData.append("cvFile", this.submittionForm.cv);
            httpClient
              .uploadSeekerCvFile(formData, localStorage.getItem("jwt-token"))
              .then((value) => {
                httpClient
                  .createNewApplication(
                    {
                      jobOffer: this.jobOffer.id,
                      coverLetter: this.submittionForm.lm,
                    },
                    localStorage.getItem("jwt-token")
                  )
                  .then((result) => {
                    console.log(result.data);
                    this.submitionOngoing = false;
                    this.submitionSucceed = true;
                  })
                  .catch((error) => {
                    if (error.response.status === 401) {
                      this.$router.push("/logout");
                    } else if (error.response.status === 503) {
                      this.snackbarFailedMessage =
                        "Vous avez déjà postulé à cette offre.";
                      this.snackbarFailed = true;
                    } else {
                      this.snackbarFailedMessage =
                        "Une erreur s'est produite avec le CV. Format invalide. Veuillez réessayer.";
                      this.snackbarFailed = true;
                    }
                  });
              })
              .catch((error) => {
                if (error.response.status === 401) {
                  this.$router.push("/logout");
                } else if (error.response.status === 503) {
                  this.snackbarFailedMessage =
                    "Vous avez déjà postulé à cette offre.";
                  this.snackbarFailed = true;
                } else {
                  this.snackbarFailedMessage =
                    "Une erreur s'est produite avec le CV. Format invalide. Veuillez réessayer.";
                  this.snackbarFailed = true;
                }
              });
          } else {
            //submit directly application
            httpClient
              .createNewApplication(
                {
                  jobOffer: this.jobOffer.id,
                  coverLetter: this.submittionForm.lm,
                },
                localStorage.getItem("jwt-token")
              )
              .then((result) => {
                console.log(result.data);
                this.submitionOngoing = false;
                this.submitionSucceed = true;
              })
              .catch((error) => {
                if (error.response.status === 401) {
                  this.$router.push("/logout");
                } else if (error.response.status === 503) {
                  this.snackbarFailedMessage =
                    "Vous avez déjà postulé à cette offre.";
                  this.snackbarFailed = true;
                } else {
                  this.snackbarFailedMessage =
                    "Une erreur s'est produite avec le CV. Format invalide. Veuillez réessayer.";
                  this.snackbarFailed = true;
                }
              });
          }
        }
      }
    },
    submitionNextStep() {
      console.log("upload", this.submittionForm.disableUploadCv);
      console.log("old cv", this.submittionForm.disableUseOldCv);
      console.log(
        "old generated",
        this.submittionForm.disableUseOldGeneratedCv
      );
      if (
        this.submittionForm.useOldCv === true ||
        this.submittionForm.cv !== null ||
        this.submittionForm.useGeneratedCv
      ) {
        this.disableContinue1 = false;
      } else {
        this.disableContinue1 = true;
      }
    },
    initialize() {
      const httpClient = new HttpClient();
      httpClient
        .getJobOffer(
          parseInt(this.$route.params.offerId),
          localStorage.getItem("jwt-token")
        )
        .then((res) => {
          console.log(res.data);
          this.jobOffer = res.data;
          this.disableSubmitMyCandidature = res.data.coverLetter;
          this.checkIfUserHasAlreadySubmitted(this.jobOffer.id);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else if (error.response.status === 404) {
            this.$router.push({ name: "not_found" });
          } else {
            alert("Une erreur s'est produite");
          }
        });
    },
  },
});
</script>

<style scoped></style>
